import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppState, ShowRequest } from '../../../core';
import { UserService } from '../../../core/services';
import { VolunteerTaskMapPoint } from '../../models/volunteer-task-map-point';
import { VolunteerTaskViewRecord } from '../../models/volunteer-task-record';
import { VolunteerTaskPointViewRecord } from '../../models/volunteer-task-point-record';

//
// Popup for clicking on marker
//
@Component({
  templateUrl: './volunteer-task-point-marker-popup.component.html',
  styleUrls: ['./volunteer-task-point-marker-popup.component.scss'],
  viewProviders: [ CommonModule]
})
export class VolunteerTaskPointMarkerPopupComponent implements OnInit {

  @Input() pt : VolunteerTaskMapPoint;
  @Input() selectedPt : VolunteerTaskMapPoint;
  @Input() volunteerTask : VolunteerTaskViewRecord;
  @Input() bShowSelectButton : boolean
  @Input() setSelectedPointFn : ( pt : VolunteerTaskMapPoint ) => void
  @Input() deleteScoutPointFn : ( pt : VolunteerTaskMapPoint ) => void
  @Input() allowEditMode : boolean = true
  @Input() changeGuard : (current: VolunteerTaskMapPoint, acceptFn: ()=>void) => void = (c,a) => a()
  @Input() showRefDataFn : ( pt : VolunteerTaskMapPoint ) => Promise<void>
  @Input() locked : boolean
  //@Input() scoutPathChangedFn : () => void
  strLat : string
  strLng : string
  volunteerTaskPoint: VolunteerTaskPointViewRecord;
  userName : string
  testResultsModalRef?: BsModalRef;
  testPointCnt: number

  constructor( protected appState: AppState,
    protected userService: UserService,
    private modalService: BsModalService ) {

  }

  ngOnInit() {
    this.strLat = this.pt.latitude ? Number(this.pt.latitude).toFixed(6) : ''
    this.strLng = this.pt.longitude ? Number(this.pt.longitude).toFixed(6) : ''
    this.volunteerTaskPoint = this.pt.taskPoint;
    //TODO this.testPointCnt = this.pathTestDoc?.testPoints?.length
    //this.seq = this.testPoint?.seqs.last()
    //if ( this.seq?.userId ) {
    //  this.userName$ = from(this.userService.getById(this.seq.userId))
    //    .pipe( map( userDoc=> userDoc ? `${userDoc.firstName} ${userDoc.lastName}` : ''))
    //}
    this.userName = this.volunteerTask.volunteerName;
  }


  openExternalUrl(url:string) {
    if ( this.appState.isElectron() ) {
      const shell = window.require('electron').shell;
      shell?.openExternal(url)
    } else {
      window.open( url, `Path Test Point ${this.pt.name}` );
    }
  }

  onShowGoogleMapsPoint(lat:string,lng:string) {
    this.openExternalUrl(`https://www.google.com/maps/place/${lat},${lng}/@${lat},${lng},21z`)
  }

  onSelectPoint = () => {
    console.log('onSelectPoint' + this.pt.name)
    this.setSelectedPointFn(this.pt)
  }

  onShowRefData = () => {
    this.showRefDataFn(this.pt)
  }

  onShowPoint = ( pointId : string ) => {
    this.appState.showView.next( new ShowRequest('tab','point', pointId) )
  }

  onShowTestResults() {
//TODO
    /*const initialState = {
      seqContext: { seq: this.seq, type: this.pathTestDoc.type }
    }
    this.testResultsModalRef =
        DialerClientTestSeqModalComponent.showModal(this.modalService, initialState)
    this.testResultsModalRef.onHide.subscribe( _ => {
      this.testResultsModalRef = null
    })
    */

  }
}